// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3FIrV","buttons":"RemoveExpirationActionButtons_buttons__RQgdv"};